import { CHART_TYPE } from './types';

export const CIRCLE2_DELAY: Record<CHART_TYPE, number> = {
	[CHART_TYPE.V1]: 2.2,
	[CHART_TYPE.V2]: 1.9,
	[CHART_TYPE.V3]: 1.6,
};
